import React, { Component } from 'react';
import { connect } from 'react-redux';
import { publishActions } from '../actions/publishActions';

export class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: '',
            endDate: '',
            subject: '',
            exam: '',
            rating: '',
            expertRating: '',
            quesState: '',
            uid: '',
            qid: ''
        };
        this.predefinedFormData = {};
        this.handleChange = this.handleChange.bind(this);
        this.submitSearch = this.submitSearch.bind(this);
        this.updateFormData = this.updateFormData.bind(this);
        
        const latexSymbols = [{}]
    }
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }
    updateFormData(fieldValue, fieldName) {
        this.predefinedFormData[fieldName] = fieldValue;
        return fieldValue;
    }
    submitSearch() {
        let searchParams = { ...this.state };
        let fromDate = this.state.fromDate;
        let endDate = this.state.endDate;

        if (this.predefinedFormData.fromDate && this.predefinedFormData.endDate) {
            fromDate = this.predefinedFormData.fromDate;
            endDate = this.predefinedFormData.endDate;
            searchParams = { ...this.state, ...this.predefinedFormData };
        }

        if (!this.state.qid && !this.state.uid && (fromDate == '' || endDate == '')) {
            alert("From and end date are required fields.");
        } else {
            searchParams.limit = 50;
            searchParams.page = 1;
            this.props.searchQuestions(searchParams);
            console.log(searchParams);
        }
    }

    render() {
        const { filters, userAuthInfo = {} } = this.props;

        if (filters) {
            const { subjects, exams } = filters;
            const { _id: subjectId } = subjects.find(({ name }) => name == userAuthInfo.subject) || {};

            return (
                <div className="box box-default">
                    {/* <div className="box-header with-border">
                                <h3 className="box-title">Select2</h3>
                            </div> */}
                    <div className="box-body">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>From Date:</label>
                                    <div className="input-group date">
                                        <input type="date" className="form-control pull-right" disabled={!userAuthInfo.isAdmin ? true : false} value={this.updateFormData(userAuthInfo.startDate, 'fromDate') || this.state.fromDate} name="fromDate" onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>End Date:</label>
                                    <div className="input-group date">
                                        <input type="date" className="form-control pull-right" disabled={!userAuthInfo.isAdmin ? true : false} value={this.updateFormData(userAuthInfo.endDate, 'endDate') || this.state.endDate} name="endDate" onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Subject:</label>
                                    <select className="form-control" title="Subject" name="subject" onChange={this.handleChange} disabled={!userAuthInfo.isAdmin ? true : false} value={this.updateFormData(subjectId, 'subject') || this.state.subject}>
                                        <option value="select"> Select Subject: </option>
                                        {subjects.map((sub, index) => (
                                            <option key={sub._id} value={sub._id}> {sub.name} </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Exam:</label>
                                    <select className="form-control" title="Exam" name="exam" onChange={this.handleChange} value={this.state.exam}>
                                        <option value="select"> Select Exam: </option>
                                        {exams.map((exam, index) => (
                                            <option key={exam._id} value={exam._id}> {exam.name} </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>User Rating:</label>
                                    <select className="form-control" title="Rating" name="rating" onChange={this.handleChange} value={this.state.rating}>
                                        <option value="select"> Select Rating: </option>
                                        <option key="1" value="1">1</option>
                                        <option key="2" value="2">2</option>
                                        <option key="3" value="3">3</option>
                                        <option key="4" value="4">4</option>
                                        <option key="5" value="5">5</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Expert Rating:</label>
                                    <select className="form-control" title="expertRating" name="expertRating" onChange={this.handleChange} disabled={!userAuthInfo.isAdmin ? true : false} value={this.updateFormData(userAuthInfo.expertRating, 'expertRating') | this.state.expertRating}>
                                        <option value="select"> Select Rating: </option>
                                        <option key="1" value="1">1</option>
                                        <option key="2" value="2">2</option>
                                        <option key="3" value="3">3</option>
                                        <option key="4" value="4">4</option>
                                        <option key="5" value="5">5</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>State:</label>
                                    <select className="form-control" title="questionState" name="quesState" onChange={this.handleChange} value={this.state.quesState}>
                                        <option value="select"> Select State: </option>
                                        <option key="1" value="published">Published</option>
                                        <option key="2" value="unpublished">Unpublished</option>
                                        <option key="3" value="indexed">Indexed</option>
                                        <option key="4" value="noindexed">NoIndexed</option>
                                        <option key="5" value="rejected">Rejected</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>UID:</label>
                                    <input type="text" className="form-control" value={this.state.uid} name="uid" onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>QID:</label>
                                    <input type="text" className="form-control" value={this.state.qid} name="qid" onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-footer">
                        <button type="submit" className="btn btn-primary" onClick={this.submitSearch}>Search</button>
                    </div>
                </div>
            );
        } else {
            return (
                <div>Loading...</div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    // const { filters } = state.publish;
    return {
        // filters
    };
};

const actionCreators = {
    searchQuestions: publishActions.searchQuestions,
    // getFilters: publishActions.getFilters
}

export default connect(mapStateToProps, actionCreators)(Search);
